<!-- =========================================================================================
  File Name: ListValue.vue
  Description: List value Edit Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="page-branch-edit">

    <vs-alert color="danger" title="Valor de lista no encontrado" :active.sync="id_not_found">
      <span>Datos de valor de lista con id {{ $route.params.id }} no encontrados. </span>
      <span>
        <span>Verifique </span><router-link :to="{name:'lists'}" class="text-inherit underline"> todas las listas</router-link>
      </span>
    </vs-alert>

    <vx-card v-show="loaded" class="mb-2">

      <div slot="no-body" class="tabs-container px-6 pt-6">
        <div class="vx-row">
          <!-- Information - Col 1 -->
          <div class="vx-col flex-1" id="account-info-col-1">
            <div class="w-full">
              <div class="w-full">
                <ejs-textbox class="e-input" type="text" floatLabelType="Auto" placeholder="Lista" v-model="data_local.list" :enabled="editing && this.id == 0"/>
              </div>
              <div class="w-full">
                <ejs-textbox class="e-input" type="text" floatLabelType="Auto" placeholder="Código" v-model="data_local.code" :enabled="editing"/>
              </div>
              <div class="w-full">
                <ejs-textbox class="e-input" type="text" floatLabelType="Auto" placeholder="Valor" v-model="data_local.value" :enabled="editing"/>
              </div>
              <div class="w-full">
                <div style="width: 100px;">
                  <ejs-numerictextbox floatLabelType="Auto" placeholder="Orden" format="N0" :enabled="editing" textAlign='Right' v-model="data_local.order"/>
                </div>
              </div>
            </div>
          </div>

        </div>

        <div class="vx-row">
          <div class="vx-col w-full mb-4">
            <div class="flex flex-wrap items-center justify-end">
              <vs-button icon-pack="feather" icon="icon-edit" class="mr-4" v-show="!editing" @click="editing = true">Editar</vs-button>
              <vs-button type="border" color="danger" icon-pack="feather" icon="icon-trash" v-show="!editing" @click="confirmDeleteRecord">Eliminar</vs-button>
              <vs-button class="ml-auto" @click="save" v-show="editing" :disabled="!validateForm">Guardar cambios</vs-button>
              <vs-button class="ml-4 mt-2" type="border" color="warning" @click="reset_data" v-show="editing">Cancelar</vs-button>
            </div>
          </div>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
  var deltaPOS_config = require('@/deltaPOS.config.js');
  import Vue from "vue";
  import {TextBoxPlugin} from '@syncfusion/ej2-vue-inputs';
  import {NumericTextBoxPlugin} from "@syncfusion/ej2-vue-inputs";

  Vue.use(TextBoxPlugin);
  Vue.use(NumericTextBoxPlugin);

  export default {
    data() {
      return {
        id: 0,
        loaded: false,
        editing: false,
        data: null,
        data_local: {
          id: 0,
          list: '',
          code: '',
          name: '',
          order: 0
        },
        id_not_found: false,
      }
    },
    methods: {
      reset_data() {
        if (this.$route.params.id > 0) {
          this.data_local = JSON.parse(JSON.stringify(this.data));
          this.editing = false;
        } else {
          this.$router.push({name: 'lists'});
        }
      },
      getData(id) {
        if (id) {
          if (id == 0) {
            this.$vs.loading.close();
            this.loaded = true;
            this.id_not_found = false;
            this.editing = true;
          } else {
            var self = this;
            var data = {
              objectId: id,
              userId: this.$store.state.AppActiveUser.userId,
              token: this.$store.state.AppActiveUser.token
            };
            this.$http.post(deltaPOS_config.default.apiURL + '/lists/get_list_value', data).then(response => {
              if (response.data.success) {
                self.data = response.data.data;
                self.data_local = JSON.parse(JSON.stringify(response.data.data));
              } else {
                if (id > 0) {
                  this.id_not_found = true;
                }
              }
              self.$vs.loading.close();
              self.loaded = true;
            })
          }
        } else {
          this.$vs.loading.close();
          this.loaded = true;
          if (id == 0) {
            this.id_not_found = false;
          }
          this.editing = true;
        }
      },
      validateForm() {
        var validated = true;
        if (!this.data_local.list || this.data_local.list == '') {
          this.$vs.notify({
            title: 'Error al guardar valor de lista',
            text: 'Debe especificar una lista',
            color: 'danger'
          });
          validated = false;
        } else if (!this.data_local.code || this.data_local.code == '') {
          this.$vs.notify({
            title: 'Error al guardar valor de lista',
            text: 'Debe especificar un código',
            color: 'danger'
          });
          validated = false;
        }
        return validated;
      },
      save() {
        if (this.validateForm()) {
          this.$vs.loading({
            text: 'Guardando valor de lista',
            type: 'point'
          });
          var self = this;
          this.data_local.id = parseInt(this.$route.params.id);
          this.data_local.context = this.$store.state.AppActiveUser;
          this.data_local.createdBy = parseInt(localStorage.getItem(`${deltaPOS_config.default.itemPrefix}UserId`));
          this.$http.post(deltaPOS_config.default.apiURL + '/lists/save_list_value', this.data_local).then(response => {
            if (response.data.success) {
              self.$vs.notify({
                title: 'Información actualizada',
                text: 'Valor de lista fue actualizado correctamente',
                color: 'primary'
              });
              if (self.id == 0) {
                self.$router.push({name: 'list_value', params: {id: response.data.data.id}});
              }
            } else {
              self.$vs.notify({
                title: 'Error al actualizar',
                text: response.data.message,
                color: 'danger'
              });
            }
            this.editing = false;
            this.$vs.loading.close();
          });
        }
      },
      confirmDeleteRecord() {
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: `Confirmar`,
          text: `Se dispone a eliminar código "${this.data.code}" de lista  "${this.data.list}"`,
          accept: this.deleteRecord,
          acceptText: "Delete"
        })
      },
      deleteRecord() {
        this.$vs.loading({
          text: 'Eliminando valor de lista',
          type: 'point'
        });
        var self = this;
        var data = {
          objectId: this.id,
          userId: this.$store.state.AppActiveUser.userId,
          token: this.$store.state.AppActiveUser.token
        };
        this.$http.post(deltaPOS_config.default.apiURL + '//lists/delete_list_value', data).then(response => {
          if (response.data.success) {
            self.$vs.notify({
              title: 'Información eliminada',
              text: 'Valor de lista fue eliminado correctamente',
              color: 'primary'
            });
            self.$router.push({name: 'lists'});
          } else {
            self.$vs.notify({
              title: 'Error al actualizar',
              text: response.data.message,
              color: 'danger'
            });
          }
          this.editing = false;
          this.$vs.loading.close();
        });
      }
    },

    mounted() {
      this.id = parseInt(this.$route.params.id);
      if (this.id > 0) {
        this.$vs.loading({
          text: 'Cargando valor de lista',
          type: 'point'
        });
      }
      this.getData(this.id);
    }
  }
</script>

<style lang="scss">
  @import '../../../../node_modules/@syncfusion/ej2-base/styles/material.css';
  @import '../../../../node_modules/@syncfusion/ej2-buttons/styles/material.css';
  /*@import '../../../../node_modules/@syncfusion/ej2-calendars/styles/material.css';*/
  @import '../../../../node_modules/@syncfusion/ej2-dropdowns/styles/material.css';
  @import '../../../../node_modules/@syncfusion/ej2-inputs/styles/material.css';
  /*@import '../../../../node_modules/@syncfusion/ej2-navigations/styles/material.css';*/
  /*@import '../../../../node_modules/@syncfusion/ej2-popups/styles/material.css';*/
  /*@import '../../../../node_modules/@syncfusion/ej2-splitbuttons/styles/material.css';*/
  /*@import "../../../../node_modules/@syncfusion/ej2-vue-grids/styles/material.css";*/

  .wrapper {
    max-width: 250px;
    margin: 0 auto;
  }

  .e-grid .e-altrow {
    background-color: #fafafa;
  }

  #avatar-col {
    width: 12rem;
  }

  #page-stock-branch-edit {
    table {
      td {
        vertical-align: top;
        min-width: 140px;
        padding-bottom: .4rem;
        word-break: break-all;
      }

      &:not(.permissions-table) {
        td {
          @media screen and (max-width: 370px) {
            display: block;
          }
        }
      }
    }
  }

  @media screen and (min-width: 1201px) and (max-width: 1211px),
  only screen and (min-width: 636px) and (max-width: 991px) {
    #account-info-col-1 {
      width: calc(100% - 12rem) !important;
    }
  }

</style>
